import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { wizardFieldSx, wizardLabelSx, wizardRequiredMarkSx } from './roleWizardConstants'

export default function RoleWizardGeneralStep({
  name,
  description,
  nameError = '',
  onNameChange,
  onDescriptionChange
}) {
  return (
    <Stack spacing={1.5}>
      <Box>
        <Typography component="label" htmlFor="role-name" sx={wizardLabelSx}>
          Nombre del rol{' '}
          <Box component="span" sx={wizardRequiredMarkSx}>
            *
          </Box>
        </Typography>
        <TextField
          id="role-name"
          value={name}
          onChange={(event) => onNameChange(event.target.value)}
          error={Boolean(nameError)}
          required
          fullWidth
          autoFocus
          placeholder="Ej. Supervisor"
          helperText={nameError || `Cantidad máxima de caracteres: ${name.length}/28`}
          sx={wizardFieldSx}
          slotProps={{ htmlInput: { maxLength: 28 } }}
        />
      </Box>

      <Box>
        <Typography component="label" htmlFor="role-description" sx={wizardLabelSx}>
          Descripción (opcional)
        </Typography>
        <TextField
          id="role-description"
          value={description}
          onChange={(event) => onDescriptionChange(event.target.value)}
          fullWidth
          multiline
          minRows={3}
          placeholder="Describe qué hace este rol"
          helperText={`${description.length}/120`}
          sx={{
            ...wizardFieldSx,
            '& .MuiOutlinedInput-root.MuiInputBase-multiline': { p: 0 },
            '& .MuiInputBase-inputMultiline': { py: 1.2, px: 1.5, ml: 0 }
          }}
          slotProps={{ htmlInput: { maxLength: 120 } }}
        />
      </Box>
    </Stack>
  )
}
